var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 11 0 21.392V.608L9 11Z","fill":"currentColor"}));
}

ArrowRight.defaultProps = {"width":"9","height":"22","viewBox":"0 0 9 22","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
